var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseValidationProvider',{attrs:{"rules":_vm.rules,"label":_vm.label,"label-for":_vm.$attrs.id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input',_vm._g(_vm._b({class:[
      'input',
      {
        'input-error': errors.length,
        'cursor-not-allowed opacity-50': _vm.disabled,
      } ],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}},'input',_vm.$attrs,false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }